import { useTranslation } from 'next-i18next';
import Router from 'next/router';
import { FC } from 'react';

import { toggleConfirmationModal } from '@/redux/slices/gui.slice';
import MillesimaLink from '@/components/common/MillesimaLink';
import { useAppDispatch } from '@/redux';
import { useServices } from '@/services/useServices';

import styles from './PromoInfoBox.module.scss';

export type PromoInfoBoxProps = {
  promoId: string;
  minimumProducts: number;
  text: string;
  customClassName?: string;
};

const PromoInfoBox: FC<PromoInfoBoxProps> = ({ promoId, minimumProducts, text, customClassName }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { promotionService } = useServices();

  const handleClick = async () => {
    const promotion = await promotionService.getPromotionById(promoId);
    if (promotion?.descriptionForModale && promotion?.urlForModale) {
      dispatch(toggleConfirmationModal({
        opened: true,
        title: t('product.details.plural'),
        customContent: promotion.descriptionForModale,
        confirm: {
          label: t('btn.seeWholeSelection'),
          action: () => Router.push(promotion?.urlForModale)
        },
        cancel: {
          label: t('btn.returnToProduct'),
          action: () => dispatch(toggleConfirmationModal({}))
        },
        groupVariant: 'secondary'
      }));
    }
  };

  const className = [
    styles.container,
    customClassName
  ].filter(Boolean).join(' ');

  return (
    <div className={className}>
      <span className={styles.box} data-test-id={'box'}>
        x{minimumProducts}
      </span>
      <p className={styles['promo-text']} data-test-id={'text'}>
        {`${text} `}
        <MillesimaLink customClassName={{ link: styles['know-more'] }} onClick={handleClick}>
          {t('btn.knowMore')}
        </MillesimaLink>
      </p>
    </div>
  );
};

export default PromoInfoBox;
